import { Check, ContentCopy } from '@mui/icons-material';
import { Button, ButtonProps } from '@mui/material';

import copy from 'copy-to-clipboard';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { translations } from 'locales/i18n';

interface CopyToClipboardButtonProps extends ButtonProps {
  textToCopy: string | null;
  error?: boolean;
  customText?: string;
}

export const CopyToClipboardButton = ({
  textToCopy,
  error,
  customText,
  style
}: CopyToClipboardButtonProps) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  return (
    <Button
      style={{ gap: '0.5rem', fontSize: '12px', ...style }}
      onClick={async () => {
        const codeString = textToCopy;
        if (codeString) {
          setIsCopied(true);
          copy(codeString, { format: 'text/plain' });

          setTimeout(() => {
            setIsCopied(false);
          }, 3000);
        }
      }}
    >
      {isCopied ? (
        <>
          <Check fontSize="small" />
          {error ? '' : t(translations.common.copied())}
        </>
      ) : (
        <>
          <ContentCopy fontSize="small" />
          {error ? '' : customText ?? t(translations.common.copy())}
        </>
      )}
    </Button>
  );
};
